import styled from "styled-components";
import { MuiTooltip } from "./MuiToolTip";
import {
  h3Regular,
  textFieldTypographyH3SemiBold,
} from "../typography/MuiTypography.style";
import { COLORS } from "../../styles/constants.style";

export const MuiStyledTooltip = styled(MuiTooltip)<{
  toolTipBgColor?: string;
  textColor?: string;
  borderWidth?: string;
  arrowBgColor?: string;
  maxWidth?: string;
}>`
  .MuiTooltip-arrow {
    color: ${(props) =>
      props.toolTipBgColor
        ? props.toolTipBgColor
        : COLORS.cirrus_tooltip_error};

    &::before {
      color: ${(props) =>
        props.arrowBgColor ? props.arrowBgColor : COLORS.cirrus_tooltip_error};
    }
  }

  .MuiTooltip-tooltip {
    background-color: ${(props) =>
      props.toolTipBgColor
        ? props.toolTipBgColor
        : COLORS.cirrus_tooltip_error};
    line-height: 19.36px;
    text-align: left;
    padding: 16.5px 16px;
    border-radius: 8px;
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "400px")};
    min-width: 330px;
    border-color: ${COLORS.cirrus_black6};
    border: 0px solid ${COLORS.cirrus_black6};
    border-width: ${(props) => (props.borderWidth ? props.borderWidth : 0)};

    .MuiTypography-root {
      ${h3Regular}
      color: ${(props) =>
        props.textColor ? props.textColor : COLORS.cirrus_black};
      line-height: 22px;
    }

    .header-title-margin {
      margin-top: 24px;
    }

    .header-title {
      ${textFieldTypographyH3SemiBold}
      color: ${(props) =>
        props.textColor ? props.textColor : COLORS.cirrus_black};
      line-height: 22px;
    }

    .MuiSvgIcon-root {
      float: right;
      color: ${COLORS.primary_light_blue};
      cursor: pointer;
      margin-left: 16px;
    }
  }
`;
